import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../setup/store/store';
import { EventModel } from '../models/event.model';

const eventAdapter = createEntityAdapter<EventModel>();

export const eventSlice = createSlice({
    initialState: eventAdapter.getInitialState(),
    name: 'events',
    reducers: {
        eventSetMany: eventAdapter.setMany,
        eventSetOne: eventAdapter.setOne,
    },
});

export const eventSelectors = eventAdapter.getSelectors<RootState>(state => state.events);
